import { render, staticRenderFns } from "./draggableContainer.vue?vue&type=template&id=487c3d41"
import script from "./draggableContainer.vue?vue&type=script&lang=js"
export * from "./draggableContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_5cxdem7bu5cwsxatf4y6tpyoxu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports